// src/services/role.service.ts
import { privateRequest, type ApiResponse } from "../axios";

export interface Role {
  Id: number;
  RoleId: number;
  Name: string;
  Description: string;
  ModifiedDate: string;
  ModifiedByUserName: string;
  CreatedByUserName: string;
  CloneRoleId: any;
  RoleName: string;
  RoleDescription: string;
  Status: number;
  Message: string;
}

export interface AuditLogs {
  Id: number;
  Note: string;
  CreatedBy: string;
  CreatedDate: string;
}

const ENDPOINTS = {
  ROLE: "api/Roles",
  ROLE_ID: (roleId: number) => `api/Roles/${roleId}`,
  ROLE_PERMISSION: "api/Roles/Permissions",
  AUDIT_LOGS_ROLE_ID: (roleId: number) => `api/Roles/AuditLogs/${roleId}`,
};

const getRoles = async (): Promise<ApiResponse<Role[]>> => {
  const response = await privateRequest.get<ApiResponse<Role[]>>(ENDPOINTS.ROLE);
  return response.data;
};

const addRole = async (data: Partial<Role>): Promise<ApiResponse<Role>> => {
  const response = await privateRequest.post<ApiResponse<Role>>(ENDPOINTS.ROLE, data);
  return response.data;
};

const updateRole = async (data: Role): Promise<ApiResponse<Role>> => {
  const response = await privateRequest.put<ApiResponse<Role>>(ENDPOINTS.ROLE, data);
  return response.data;
};

const deleteRole = async (roleId: number): Promise<ApiResponse<Role>> => {
  const response = await privateRequest.delete<ApiResponse<Role>>(ENDPOINTS.ROLE_ID(roleId));
  return response.data;
};

const getPermissions = async (roleId: number): Promise<ApiResponse<any>> => {
  const response = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.ROLE_ID(roleId) + "/Permissions");
  return response.data;
};

const updatePermission = async (
  data: any,
  signal?: AbortSignal
): Promise<ApiResponse<any>> => {
  const response = await privateRequest.put<ApiResponse<any>>(
    ENDPOINTS.ROLE_PERMISSION,
    data,
    signal ? { signal } : {}
  );
  return response.data;
};

const getAuditLogsById = async (roleId: number): Promise<ApiResponse<AuditLogs[]>> => {
  const response = await privateRequest.get<ApiResponse<AuditLogs[]>>(ENDPOINTS.AUDIT_LOGS_ROLE_ID(roleId));
  return response.data;
};

const RoleService = {
  getRoles,
  addRole,
  updateRole,
  deleteRole,
  getPermissions,
  updatePermission,
  getAuditLogsById,
};

export default RoleService;
